import { post, del } from "../../httpService";

export const postUserJathgan = (user) => post("/jaadhagams/new", user);
export const contactUs = info => post("/contact-us", info);